import { render, staticRenderFns } from "./moderation.pug?vue&type=template&id=64c98a66&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./moderation.scss?vue&type=style&index=0&id=64c98a66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c98a66",
  null
  
)

export default component.exports